// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./lib/turbo_stream_actions"

import "trix"
import "@rails/actiontext"

Trix.config.blockAttributes.default.tagName = "p"